//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { EventCategoryNameDisplayItem } from './EventCategoryNameDisplayItem';
import { PayrollOverrideType } from './Enums';

export class EventCategoryDisplayItem extends EventCategoryNameDisplayItem {
    Active: boolean = false;
    AllowMakeUpCredits: boolean = false;
    BlocksOtherRecurringEvents: boolean = false;
    EmailReminderHours: number = 0;
    EmailReminders: boolean = false;
    IsForTransactions: boolean = false;
    IsPrimary: boolean = false;
    IsUseable: boolean = false;
    IsUserGenerated: boolean = false;
    IsRepertoire: boolean = false;
    IsBirthday: boolean = false;
    PayrollOverride: PayrollOverrideType | null = null;
    PayrollOverrideAmount: number | null = null;
    SMSReminderHours: number = 0;
    SMSReminders: boolean = false;
    EventCount: number | null = null;

    constructor(initializer?: Partial<EventCategoryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "EventCategoryDisplayItem";
}
